/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.curated.CuratedRecommendationsService
 */

export const getCuratedRecommendationsRpc = {
  serviceName: 'com.hubspot.academy.recommendations.rpc.curated.CuratedRecommendationsService',
  rpcName: 'getCuratedRecommendations',
  auth: 'app',
  fingerprint: 's_zYwCFR-AQfTDNvp8-gNomjoV7TREB2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};